import type { ScenarioPackage } from "@mobile/runtime/types";
import { sentenceBelongsToIntent } from "@mobile/runtime/intentSentenceMembership";

export type WebAudioUnitType = "intentHeading" | "scenarioVocabulary" | "scenarioMissions";

export function buildWebAudioUnitRefs(
  scenario: ScenarioPackage,
  unitType: WebAudioUnitType,
  unitId: string,
): string[] {
  const sentenceById = new Map(scenario.sentenceLibrary.map((sentence) => [sentence.sentenceId, sentence]));
  const refs = unitType === "intentHeading"
    ? scenario.sentenceLibrary
      .filter((sentence) => sentenceBelongsToIntent(sentence, unitId))
      .map((sentence) => sentence.audioRef)
    : unitType === "scenarioVocabulary"
      ? [
          ...(scenario.vocabularyLibrary || []).map((item) => item.audioRef),
          ...(scenario.vocabularyLibrary || []).flatMap((item) => (
            (item.sentenceIds || []).map((sentenceId) => sentenceById.get(sentenceId)?.audioRef)
          )),
        ]
      : (scenario.taskStructure.simulationObjectives || []).flatMap((objective) => (
          [
            objective.sentenceId,
            objective.systemLeadSentenceId,
            objective.systemReplySentenceId,
            objective.promptSimulationSentenceId,
          ].map((sentenceId) => sentenceById.get(String(sentenceId || ""))?.audioRef)
        ));

  return Array.from(new Set(refs.filter((audioRef): audioRef is string => Boolean(audioRef))));
}
